import React,{useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import Blank from '../iconpages/blanks';
import RVWS_account_dashboard from "./rvws_account_dashboard.jsx";
import Term_procurement_account_dashboard from './term_procurement_account_dashboard.jsx';
function Dashboardacc() {
   const location = useLocation();
  const [name, setName] = useState('');
  const accountId = localStorage.getItem('userDetails');
  const [currentComponent, setCurrentComponent] = useState(<Term_procurement_account_dashboard/>);
  const [activeComponent, setActiveComponent] = useState("term_procurement_account_dash");

  useEffect(()=>{
    if(accountId){
      const userDetails = JSON.parse(accountId);
      setName(userDetails.name);
    }
  },[])

  useEffect(()=>{
      const getSearch = location.search;
      if(getSearch.includes('rvws_account_dash')){
        setActiveComponent("rvws_account_dash")
        setCurrentComponent(<RVWS_account_dashboard/>)
      } 
      else if(getSearch.includes('term_procurement_account_dash')){
        setActiveComponent("term_procurement_account_dash")
        setCurrentComponent(<Term_procurement_account_dashboard/>)
      } 
  
    },[location])

    const handleComponentChange = (component) => {
    setCurrentComponent(component);
  };

  return (
    <div className="wbshor">
      <div className="login-header-wrap">
        <div className="login-header">
          <div className="pagetitle">{name}</div>
          <div className="button-wrapper">
            {/* <button className="btntopright" id="optionsBtn">
              <p>&lt;</p>
            </button> */}
            <div className="options-popup" id="optionsPopup">
              <button className="option-btn yellow">
                Filter <i>▼</i>
              </button>
              <button className="option-btn">
                Export report <i>▼</i>
              </button>
              <button className="option-btn">
                Hide Columns <i>▼</i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="innerwrap">
          <div className="leftbar">
            {/* <button className="option-btn btn1 active">
              <span>
                <strong>Dashboard 1</strong>
              </span>
            </button> */}
          
            {/* 
            <button className="option-btn btn1">
              <span>
                <strong>Project Dashboard</strong>
              </span>
            </button>*/}
            {/* <button className="option-btn btn1">
              <span>
                <strong>Term Procurement</strong>
              </span>
            </button> */}
            {/* <button className="option-btn btn1">
              <span>
                <strong>RVWS Dashboard</strong>
              </span>
            </button> */}

            <button className={`option-btn btn1 ${activeComponent === "term_procurement_account_dash" ? 'active' : ''}`} onClick={() => { setActiveComponent("term_procurement_account_dash"); handleComponentChange(<Term_procurement_account_dashboard />) }}>
              <span><strong>Term Procurement</strong></span>
            </button>
            <button className={`option-btn btn1 ${activeComponent === "rvws_account_dash" ? 'active' : ''}`} onClick={() => { setActiveComponent("rvws_account_dash"); handleComponentChange(<RVWS_account_dashboard />) }}>
              <span><strong>RVWS Dashboard</strong></span>
            </button>
            
          </div>
              {currentComponent}
          {/* <Blank/> */}
        </div>
      </div>
    </div>
  );
}

export default Dashboardacc;
